<template>
  <div class="Trade">
    <!-- <div
        class="page-segment-input bottom-margin-10"
        v-if="currentEnvironment.optionsTrade"
      >
        <el-radio v-model="page_segment" label="equity" @change="clearAllFields()"
          >Equity</el-radio
        >
        <el-radio
          v-model="page_segment"
          label="options"
          @change="clearAllFields()"
          >Options</el-radio
        >
      </div> -->

    <div class="bottom-margin-10 segment-radio-btn page-segment-input" v-if="currentEnvironment.optionsTrade && $route.path == '/trading'">
      <el-button
        size="mini"
        :class="page_segment == 'equity' ? 'btn-theme-filled' : 'btn-theme-borderd'"
        @click="
          clearAllFields();
          page_segment = 'equity';
        "
      >
        Equity
      </el-button>
      <el-button
        size="mini"
        :class="page_segment == 'options' ? 'btn-theme-filled' : 'btn-theme-borderd'"
        @click="
          clearAllFields();
          page_segment = 'options';
        "
      >
        Options
      </el-button>
    </div>

    <el-row :gutter="10">
      <el-col :xs="24" :sm="24" :md="$route.path != '/trading' ? 24 : 12" :lg="$route.path != '/trading' ? 24 : 12" :xl="$route.path != '/trading' ? 24 : 12">
        <el-card class="box-card trading-card" :style="[selected_trade_type == 'BUY' && $route.path == '/trading' ? { borderTop: '6px solid #3cb55d' } : selected_trade_type == 'SELL' && $route.path == '/trading' ? { borderTop: '6px solid #e8353f' } : { borderTop: 'none' }]" v-loading="is_trading_details_loading || is_ltp_loading">
          <div v-if="page_segment == 'equity'">
            <div class="search-stock relative" v-if="$route.path == '/trading'">
              <el-select v-model="search_stock" filterable remote reserve-keyword placeholder="Search e.g infosys, 3m india" class="custom-seach-input" size="small" clearable :loading="stocks_loading" :remote-method="searchStockList" @change="handleStock(search_stock)">
                <el-option v-for="stock in stocks_list" :key="stock.id" :label="stock.name ? stock.name : stock.title" :value="stock.id">
                  <div class="flex">
                    <div class="searched-stock-title ellipsis">
                      {{ stock.name ? stock.name : stock.title }}
                    </div>
                    &nbsp;
                    <div class="input-label-gray" v-if="stock.symbol || stock.expiry">({{ stock.symbol ? stock.symbol : moment(stock.expiry).format('DD MMM YYYY') }})</div>
                  </div>
                </el-option>
              </el-select>
              <i class="el-icon-search search-icon" style="top: 8px" v-if="!search_stock"></i>
            </div>

            <div class="top-margin-15" style="padding: 0 10px" v-if="stock_details.name && (bse_ltp || nse_ltp)">
              <div class="top-margin-10 bottom-margin-25 text-left font-08rem font-weight-500" style="color: #9a9a9a; font-weight: 600; margin-left: 5px" v-if="currentEnvironment.utm_source == 'Maitra Commodities'">
                <!-- Note: BSE trade not available -->
              </div>
              <div class="bottom-margin-10 searched-stock-title" style="display: flex; align-items: center; gap: 20px">
                <span class="label" style="color: #5d5d5d; font-size: 12px; font-weight: 500; white-space: nowrap">Stock Name:</span>
                <span style="font-size: 17px; font-weight: 600; padding-top: 2px">{{ stock_details.name }}</span>
              </div>

              <div class="top-margin-5">
                <el-row :gutter="6">
                  <el-col :xs="24" :sm="12" :md="10" :lg="10" :xl="10">
                    <div class="price-container">
                      <span class="price-label">Prices:</span>

                      <!-- Dropdown and input field container -->
                      <div class="stock-select-container">
                        <el-select v-model="stock_type" @change="checkPrice(stock_type)" size="small" class="custom-dropdown blue-dropdown">
                          <el-option v-if="bse_ltp" label="BSE Prices" value="BSE"></el-option>
                          <el-option v-if="nse_ltp" label="NSE Prices" value="NSE"></el-option>
                        </el-select>

                        <el-input :value="stock_type === 'BSE' ? `₹${bse_ltp}` : `₹${nse_ltp}`" disabled size="small" class="ltp-input">
                          <template #suffix>
                            <div class="refresh-icon-container" @click="refreshLTP">
                              <img src="../assets/images/Refresh.svg" alt="Refresh Icon" class="refresh-icon" style="margin-top: 10px" />
                            </div>
                          </template>
                        </el-input>
                      </div>
                    </div>
                  </el-col>
                </el-row>
              </div>
              <hr style="border-top: 1px solid #dddd; margin: 25px 0 20px" />
              <div class="top-margin-20">
                <el-row :gutter="10" style="display: flex; justify-content: center; align-items: center; text-align: center">
                  <el-col :xs="12" :sm="8" :md="8" :lg="8" :xl="8" v-for="(type, type_index) in validity_list" :key="type_index" style="display: flex; justify-content: center">
                    <el-radio :disabled="order_id != null" v-model="validity" :label="type.value" @change="validity == 'B' ? checkPrice(stock_type) : (order_selection_type = false)">
                      {{ type.title }}
                    </el-radio>
                  </el-col>

                  <el-col :xs="12" :sm="8" :md="8" :lg="8" :xl="8" v-if="userProfile.utm_source == 'AliceBlue'" style="display: flex; justify-content: center">
                    <el-checkbox v-if="validity == 'MIS' && stock_type == 'NSE'" v-model="order_selection_type" @change="checkPrice(stock_type)" :label="order_selection_type">Bracket Order</el-checkbox>
                  </el-col>
                </el-row>
              </div>

              <div class="top-margin-15">
                <el-row :gutter="12">
                  <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
                    <div style="display: flex; align-items: center; justify-content: space-between; margin-bottom: 10px">
                      <label style="font-size: 12px; font-weight: 500; width: 120px; white-space: nowrap; color: #5d5d5d">Quantity</label>
                      <el-input-number v-model="quantity" size="mini" :min="1" :step="1" style="width: 100%" class="custom-input-number"></el-input-number>
                    </div>
                  </el-col>

                  <!-- Entry Price Column -->
                  <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
                    <div style="display: flex; align-items: center; justify-content: space-between">
                      <label style="font-size: 12px; font-weight: 500; width: 120px; white-space: nowrap; color: #5d5d5d">Entry Price</label>
                      <el-input v-model="price" size="mini" :disabled="price_limit == 'MARKET'" :precision="2" :min="0" :step="0.1" @change="checkPrice(stock_type)" style="width: 100%" type="number">
                        <template #prefix>
                          <span style="font-weight: bold; display: flex; justify-content: center; padding-left: 5px; color: black; padding-top: 7px; padding-bottom: 5px">₹</span>
                        </template>
                      </el-input>
                    </div>
                    <div style="display: flex; margin-top: 10px; justify-content: flex-end">
                      <el-radio
                        v-if="!((currentEnvironment && currentEnvironment.utm_source == 'Share India Trade') || currentUrl.includes('shareindia-trade.stockants.com'))"
                        v-model="price_limit"
                        label="MARKET"
                        @change="
                          price = '';
                          setPrice(stock_type, 'MARKET');
                        "
                        :disabled="isMarketClose"
                      >
                        Market
                      </el-radio>
                      &nbsp;&nbsp;
                      <el-radio v-model="price_limit" label="LIMIT" @change="setPrice(stock_type, 'LIMIT')">Limit</el-radio>
                    </div>
                  </el-col>
                </el-row>
              </div>

              <!-- Stoploss and Target Price Row -->
              <div v-if="order_selection_type || (validity == 'I' && userProfile.utm_source == 'Paytm Money')" class="top-margin-15">
                <el-row :gutter="12" class="top-margin-20">
                  <!-- Stoploss Column -->
                  <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
                    <div style="display: flex; align-items: center; justify-content: space-between; margin-bottom: 10px">
                      <label style="font-size: 0.8rem; width: 120px; white-space: nowrap">Stoploss</label>
                      <el-input v-model="stop_loss" size="mini" placeholder="Enter stoploss" style="width: 100%; background-color: #f8f8f8" type="number">
                        <template #prefix>
                          <span style="font-weight: bold; display: flex; justify-content: center; padding-left: 5px; color: black; padding-top: 7px; padding-bottom: 5px">₹</span>
                        </template>
                      </el-input>
                    </div>
                    <div class="required-field top-margin-5 bottom-margin-5" style="font-size: 10px" v-if="isStopLossInvalid">Stop loss should be lower than entry price</div>
                  </el-col>

                  <!-- Target Price Column -->
                  <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
                    <div style="display: flex; align-items: center; justify-content: space-between">
                      <label style="font-size: 0.8rem; width: 120px; white-space: nowrap">Target Price</label>
                      <el-input v-model="target_price" size="mini" placeholder="Enter target price" style="width: 100%; background-color: #f8f8f8" type="number">
                        <template #prefix>
                          <span style="font-weight: bold; display: flex; align-items: center; justify-content: center; padding-left: 5px; color: black; padding-top: 7px; padding-bottom: 5px">₹</span>
                        </template>
                      </el-input>
                    </div>
                    <div class="required-field top-margin-5 bottom-margin-5" style="font-size: 10px" v-if="active_price > target_price && target_price">Target Price should be greater than entry price</div>
                  </el-col>
                </el-row>
              </div>

              <div class="divider" style="border-top: 1px solid #929292; padding: 0 30px 0px; border-radius: 20px 20px 0px 0px; overflow: hidden; margin-top: 20px; margin-left: -35px; margin-right: -35px; box-shadow: 0px -4px 6px rgba(0, 0, 0, 0.1)">
                <el-row :gutter="12" style="width: 100%; margin-top: 20px">
                  <el-col :xs="24" :sm="12" :md="12" :lg="12" :xl="12">
                    <div style="margin-bottom: 10px">
                      <label style="display: block; font-size: 12px; font-weight: 500; margin-bottom: 5px; color: #5d5d5d">Capital req (Approx. Funds)</label>
                      <el-input
                        v-model="capitalRequiredComputed"
                        size="medium"
                        :disabled="!isEditable"
                        :style="{
                          width: '100%',
                          fontSize: '16px',
                          fontWeight: 'bold',
                          color: '#000000',
                        }"
                      >
                        <!-- Prefix: ₹ symbol -->
                        <template #prefix>
                          <span style="display: flex; align-items: center; justify-content: center; font-weight: bold; font-size: 16px; color: #000000; padding: 5px 0px 10px 10px">₹</span>
                        </template>

                        <!-- Suffix: Edit Icon -->
                        <template #suffix>
                          <img src="../assets/images/Edit.svg" alt="Edit" style="width: 16px; height: 16px; cursor: pointer; padding: 10px" @click="toggleEdit" />
                        </template>
                      </el-input>
                    </div>
                  </el-col>

                  <!-- Available Funds and Buy Button -->
                  <el-col :xs="24" :sm="12" :md="12" :lg="12" :xl="12">
                    <div style="margin-bottom: 10px">
                      <div style="display: flex; align-items: center; gap: 10px; margin-bottom: 2px">
                        <label style="font-size: 12px; font-weight: 500; color: #5d5d5d">Available Funds:</label>
                        <span style="font-weight: 500; font-size: 16px; color: #000000">
                          ₹
                          {{ funds.available_cash ? funds.available_cash : '00.00' }}
                        </span>
                      </div>
                      <el-button
                        size="mini"
                        :style="[
                          {
                            marginTop: '0px',
                            width: '100%',
                            color: '#FFFFFF',
                            fontSize: '15px',
                            fontWeight: 600,
                            height: '35px',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            gap: '8px',
                            padding: '0',
                          },
                          selected_trade_type == 'BUY' || selected_trade_type == 'Buy' ? { background: '#3cb55d', borderColor: '#3cb55d' } : { background: '#e8353f', borderColor: '#e8353f' },
                        ]"
                        v-if="!order_id"
                        class="order-btn"
                        :disabled="checkValidationForBO()"
                        @click="placeOrder('place')"
                        :loading="is_order_placing"
                      >
                        <!-- Icon -->
                        <img src="../assets/images/BUY & TRADE.svg" alt="Buy Icon" style="width: 16px; height: 16px; vertical-align: middle; margin-right: 5px" />
                        <!-- Text -->
                        <span style="vertical-align: middle">Buy</span>
                      </el-button>

                      <el-button v-else class="order-btn" :style="[selected_trade_type == 'BUY' || selected_trade_type == 'Buy' ? { background: '#3cb55d', borderColor: '#3cb55d' } : { background: '#e8353f', borderColor: '#e8353f' }]" :disabled="checkValidationForBO()" @click="placeOrder('modify')" :loading="is_order_placing">Modify Order</el-button>
                    </div>
                    <div class="disclaimer-card" style="float: right">
                      <div class="input-label-bold-gray" style="margin-top: 5px">
                        <el-popover placement="bottom" title="Disclaimer" width="200" trigger="click" content="StockAnts allows trade placement through broker. facilities provided by broker will be allowed on trade.">
                          <img class="info-Logo cursor-pointer" src="../assets/images/Info.svg" style="height: 12px; top: 1px" alt slot="reference" />
                        </el-popover>
                        Disclaimer
                      </div>
                    </div>
                  </el-col>
                </el-row>

                <div class="top-margin-10 font-07rem font-weight-500">Note: Sorry! We don't allow sell transactions on StockAnts.</div>
              </div>
            </div>

            <div>
              <div class="top-margin-25 text-center font-08rem font-weight-500 primary-theme-color" v-if="!stock_details.name && (!bse_ltp || !nse_ltp) && $route.path == '/trading'">Search Stock to start investing</div>
              <div class="top-margin-25 text-center font-08rem font-weight-500 primary-theme-color" v-if="stock_details.name && !bse_ltp && !nse_ltp">Trading not available</div>
            </div>
          </div>

          <div v-if="page_segment == 'options'">
            <el-row v-if="$route.path == '/trading'">
              <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
                <div class="search-stock relative">
                  <el-select v-model="search_indice" filterable remote reserve-keyword placeholder="Search e.g NIFTY, FINNIFTY" class="custom-seach-input" size="small" clearable :loading="stocks_loading" :remote-method="searchStockList" @change="getStrikePrice(search_indice)" :disabled="isOptionsTradeFromExpertView">
                    <el-option v-for="stock in stocks_list" :key="stock.id" :label="stock.name ? stock.name : stock.title" :value="stock.id">
                      <span class="searched-stock-title">{{ stock.name ? stock.name : stock.title }}</span>
                      &nbsp;
                      <span class="input-label-gray" v-if="stock.symbol || stock.expiry">({{ stock.symbol ? stock.symbol : moment(stock.expiry).format('DD MMM YYYY') }})</span>
                    </el-option>
                  </el-select>
                  <i class="el-icon-search search-icon" style="top: 8px" v-if="!search_indice"></i>
                </div>
              </el-col>
              <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
                <div class="flex search-stock-container">
                  <el-select v-model="search_stock" size="small" collapse-tags filterable clearable placeholder="Strike Price" class="custom-seach-input" :loading="strikeLoading" @change="getDataForOptions(search_stock)">
                    <el-option v-for="strike_data in strikeData" :key="strike_data.label" :label="strike_data.label" :value="strike_data.id">
                      {{ strike_data.label }}
                    </el-option>
                  </el-select>
                </div>
              </el-col>
            </el-row>

            <div class="top-margin-10 bottom-margin-25 text-left font-08rem font-weight-500" style="color: #9a9a9a; font-weight: 600; margin-left: 5px" v-if="$route.path == '/trading'">Note: Trade is available - BankNifty, Finifty, Nifty50, Reliance Industries, HDFC Bank, State Bank Of India, ITC , Bajaj Finance, Oil & Natural Gas Corporation, Axis Bank, ICICI Bank, Infosys, Tata Motors</div>
            <div class="top-margin-15" style="padding: 0 10px" v-if="indice_ltp != null && indice_ltp > 0 && selectedStockTitle">
              <div class="bottom-margin-10 searched-stock-title" style="display: flex; flex-wrap: wrap">
                <span class="label" style="color: #5d5d5d; font-size: 12px; font-weight: 500; white-space: nowrap; margin-right: 40px">Stock Name:</span>
                <span style="font-size: 17px; font-weight: 600; padding-top: 2px">
                  {{ selectedStockTitle }}
                </span>
              </div>

              <div class="top-margin-5">
                <el-row :gutter="5">
                  <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
                    <div class="stock-select-container">
                      <span style="color: #5d5d5d; font-size: 12px; font-weight: 500; white-space: nowrap">Last Traded Price:</span>

                      <span>
                        <el-input :value="`₹ ${indice_ltp ? indice_ltp : 0}`" disabled size="small" class="ltp-input">
                          <template #suffix>
                            <div class="refresh-icon-container" @click="refreshLTP">
                              <img src="../assets/images/Refresh.svg" alt="Refresh Icon" class="refresh-icon" style="margin-top: 10px" />
                            </div>
                          </template>
                        </el-input>
                      </span>
                    </div>
                  </el-col>

                  <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24" v-if="!optionsSelectedOrderType">
                    <div class="checkbox-container" style="display: flex; justify-content: center; align-items: center; margin-top: 20px">
                      <el-radio-group v-model="selected_trade_type" size="small" class="radio-group" style="display: flex; justify-content: center; gap: 30px; margin-top: 10px">
                        <el-radio :label="'BUY'" class="radio-item" style="margin-top: 5px">BUY</el-radio>
                        <el-radio :label="'SELL'" class="radio-item" style="margin-top: 5px">SELL</el-radio>
                      </el-radio-group>
                    </div>
                  </el-col>
                </el-row>
              </div>

              <hr style="border-top: 1px solid #dddd; margin: 25px 0 20px" />

              <!-- <div class="top-margin-20">
                  <el-row :gutter="10">
                    <el-col :xs="12" :sm="8" :md="8" :lg="8" :xl="8">
                      <div class="trading-type-btn" :class="[
                        selected_trade_type == 'BUY' ? 'active-buy-btn' : '',
                      ]" @click="selected_trade_type = 'BUY'">
                        BUY
                      </div>
                    </el-col>
  
                    <el-col :xs="12" :sm="7" :md="7" :lg="7" :xl="7" v-if="selected_trade_type == 'SELL'">
                      <div class="trading-type-btn" :class="[
                        selected_trade_type == 'SELL' ? 'active-sell-btn' : '',
                      ]" @click="selected_trade_type = 'SELL'">
                        SELL
                      </div>
                    </el-col>
                  </el-row>
                </div> -->

              <div class="top-margin-20 label-md-bold-black">
                <el-row :gutter="10">
                  <el-col :xs="12" :sm="8" :md="8" :lg="8" :xl="8" v-for="(type, type_index) in validity_list" :key="type_index">
                    <el-radio :disabled="order_id != null" v-model="validity" :label="type.value" v-if="userProfile.utm_source != 'Zebu' && userProfile.utm_source != 'Enrich Money'" @change="validity == 'B' ? checkPrice(indice_ltp, 'option') : (order_selection_type = false)">{{ type.title }}</el-radio>

                    <el-radio :disabled="order_id != null" v-model="validity" :label="type.value" v-if="(userProfile.utm_source == 'Zebu' || userProfile.utm_source == 'Enrich Money') && type.value != 'C'" @change="validity == 'B' ? checkPrice(indice_ltp, 'option') : (order_selection_type = false)">{{ type.title }}</el-radio>
                  </el-col>

                  <el-col :xs="12" :sm="8" :md="8" :lg="8" :xl="8" v-if="userProfile.utm_source == 'AliceBlue'">
                    <el-checkbox v-if="validity == 'MIS'" v-model="order_selection_type" @change="checkPrice(indice_ltp, 'option')" :label="order_selection_type">Bracket Order</el-checkbox>
                  </el-col>
                </el-row>
              </div>

              <div class="top-margin-15">
                <el-row :gutter="12">
                  <!-- Lot Quantity Section for options-->
                  <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
                    <div style="display: flex; align-items: center; justify-content: space-between; margin-bottom: 10px">
                      <label style="font-size: 12px; font-weight: 500; margin-right: 10px; width: 80px; white-space: nowrap; color: #5d5d5d">Lot Quantity</label>
                      <el-input-number v-model="quantity" :precision="2" size="mini" :min="1" :step="1" style="width: 100%" class="custom-input-number"></el-input-number>
                    </div>
                    <div style="font-size: 12px; color: #5d5d5d; text-align: right; margin-bottom: 10px">Lot Size: {{ selected_lot_size }}</div>
                  </el-col>

                  <!-- Entry Price Section for options-->
                  <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
                    <div style="display: flex; align-items: center; justify-content: space-between">
                      <label style="font-size: 12px; font-weight: 500; margin-right: 20px; width: 80px; white-space: nowrap; color: #5d5d5d">Entry Price</label>
                      <el-input v-model="price" size="mini" :disabled="price_limit === 'MARKET'" @change="checkPrice(indice_ltp, 'option')" style="width: 100%" class="custom-input-number">
                        <template #prefix>
                          <span style="font-weight: bold; display: flex; justify-content: center; padding-left: 5px; color: black; padding-top: 7px; padding-bottom: 5px">₹</span>
                        </template>
                      </el-input>
                    </div>
                    <div style="display: flex; margin-top: 10px; justify-content: flex-end">
                      <el-radio
                        v-if="!((currentEnvironment && currentEnvironment.utm_source == 'Share India Trade') || currentUrl.includes('shareindia-trade.stockants.com'))"
                        v-model="price_limit"
                        label="MARKET"
                        @change="
                          price = '';
                          setPrice(indice_ltp, 'MARKET');
                        "
                        :disabled="isMarketClose"
                      >
                        Market
                      </el-radio>
                      &nbsp;&nbsp;
                      <el-radio v-model="price_limit" label="LIMIT" @change="setPrice(indice_ltp, 'LIMIT')">Limit</el-radio>
                    </div>
                  </el-col>
                </el-row>

                <el-row v-if="currentEnvironment.utm_source == 'Bajaj Broking'" :gutter="12" style="margin-top: 10px">
                  <el-col :xs="12" :sm="12" :md="8" :lg="8" :xl="8">
                    <label class="input-label block bottom-margin-5" style="font-size: 0.8rem; display: flex; align-items: center">
                      Market Protection
                      <el-popover placement="top" title="Add a protection to your BUY / SELL Market Order to avoid the risk of sudden volatility in the market (Range OPT - 5 to 10)" width="250" trigger="hover" popper-class="popover-title-black">
                        <i slot="reference" class="el-icon-info cursor-pointer font-1rem" style="margin-left: 2px"></i>
                      </el-popover>
                    </label>

                    <el-input-number v-model="market_protection" controls-position="right" size="mini" :min="5" :max="10"></el-input-number>
                  </el-col>
                </el-row>
              </div>

              <!-- Stoploss and Target Price Row for options-->
              <div v-if="order_selection_type || (validity == 'I' && userProfile.utm_source == 'Paytm Money')" class="top-margin-15">
                <el-row :gutter="12" class="top-margin-20">
                  <!-- Stoploss Column -->
                  <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
                    <div style="display: flex; align-items: center; justify-content: space-between; margin-bottom: 10px">
                      <label style="font-size: 0.8rem; margin-right: 30px; width: 80px; white-space: nowrap">Stoploss</label>
                      <el-input v-model="stop_loss" size="mini" style="width: 100%; background-color: #f8f8f8" type="number">
                        <template #prefix>
                          <span style="font-weight: bold; display: flex; justify-content: center; padding-left: 5px; color: black; padding-top: 7px; padding-bottom: 5px">₹</span>
                        </template>
                      </el-input>
                    </div>
                    <div class="required-field top-margin-5 bottom-margin-5" style="font-size: 10px" v-if="stop_loss > (indice_ltp || entry_price) && stop_loss">Stop loss should be lower than entry price</div>
                  </el-col>

                  <!-- Target Price Column -->
                  <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
                    <div style="display: flex; align-items: center; justify-content: space-between">
                      <label style="font-size: 0.8rem; margin-right: 10px; width: 80px; white-space: nowrap">Target Price</label>
                      <el-input v-model="target_price" size="mini" style="width: 100%; background-color: #f8f8f8" type="number">
                        <template #prefix>
                          <span style="font-weight: bold; display: flex; justify-content: center; padding-left: 5px; color: black; padding-top: 7px; padding-bottom: 5px">₹</span>
                        </template>
                      </el-input>
                    </div>
                    <div class="required-field top-margin-5 bottom-margin-5" style="font-size: 10px" v-if="active_price > target_price && target_price">Target Price should be greater than entry price</div>
                  </el-col>
                </el-row>
              </div>

              <div class="divider" style="border-top: 1px solid #929292; padding: 0 30px 0px; border-radius: 20px 20px 0px 0px; overflow: hidden; margin-top: 20px; margin-left: -35px; margin-right: -35px; box-shadow: 0px -4px 6px rgba(0, 0, 0, 0.1)">
                <el-row :gutter="12" style="width: 100%; margin-top: 20px">
                  <el-col :xs="24" :sm="12" :md="12" :lg="12" :xl="12">
                    <div style="margin-bottom: 10px">
                      <label style="display: block; font-size: 12px; font-weight: 500; margin-bottom: 5px; color: #5d5d5d">Capital req (Approx. Funds)</label>
                      <el-input
                        v-model="capitalRequiredValue"
                        size="medium"
                        :disabled="!isEditable"
                        :style="{
                          width: '100%',
                          fontSize: '16px',
                          fontWeight: 'bold',
                          color: '#000000',
                        }"
                      >
                        <!-- Prefix: ₹ symbol -->
                        <template #prefix>
                          <span style="display: flex; align-items: center; justify-content: center; font-weight: bold; font-size: 16px; color: #000000; padding: 5px 0px 10px 10px">₹</span>
                        </template>

                        <!-- Suffix: Edit Icon -->
                        <template #suffix>
                          <img src="../assets/images/Edit.svg" alt="Edit" style="width: 16px; height: 16px; cursor: pointer; padding: 10px" @click="toggleEdit" />
                        </template>
                      </el-input>
                    </div>
                  </el-col>

                  <!-- Available Funds and Buy Button -->
                  <el-col :xs="24" :sm="12" :md="12" :lg="12" :xl="12">
                    <div style="margin-bottom: 10px">
                      <div style="display: flex; align-items: center; gap: 10px; margin-bottom: 2px">
                        <label style="font-size: 12px; font-weight: 500; color: #5d5d5d">Available Funds:</label>
                        <span style="font-weight: 500; font-size: 16px; color: #000000">
                          ₹
                          {{ funds.available_cash ? funds.available_cash : '00.00' }}
                        </span>
                      </div>
                      <el-button
                        size="mini"
                        :style="[
                          {
                            marginTop: '0px',
                            width: '100%',
                            color: '#FFFFFF',
                            fontSize: '15px',
                            fontWeight: 600,
                            height: '35px',
                            display: 'flex',
                            alignItems: 'center' /* Vertically center the content */,
                            justifyContent: 'center' /* Horizontally center the content */,
                            gap: '8px' /* Adds space between icon and text */,
                            padding: '0' /* Removes default padding */,
                          },
                          selected_trade_type == 'BUY' || selected_trade_type == 'Buy' ? { background: '#3cb55d', borderColor: '#3cb55d' } : { background: '#e8353f', borderColor: '#e8353f' },
                        ]"
                        v-if="!order_id"
                        class="order-btn"
                        :disabled="checkValidationForBO()"
                        @click="placeOrderOptions('place')"
                        :loading="is_order_placing"
                      >
                        <!-- Icon -->
                        <img src="../assets/images/BUY & TRADE.svg" alt="Buy Icon" style="width: 16px; height: 16px; vertical-align: middle; margin-right: 5px" />
                        <!-- Text -->
                        <span style="vertical-align: middle">
                          {{ selected_trade_type ? selected_trade_type : 'Place order' }}
                        </span>
                      </el-button>
                    </div>
                    <div class="disclaimer-card" style="float: right">
                      <div class="input-label-bold-gray" style="margin-top: 5px">
                        <el-popover placement="bottom" title="Disclaimer" width="200" trigger="click" content="StockAnts allows trade placement through broker. facilities provided by broker will be allowed on trade.">
                          <img class="info-Logo cursor-pointer" src="../assets/images/Info.svg" style="height: 12px; top: 1px" alt slot="reference" />
                        </el-popover>
                        Disclaimer
                      </div>
                    </div>
                  </el-col>
                </el-row>
              </div>
            </div>

            <div class="top-margin-25 text-center font-08rem font-weight-500 primary-theme-color" v-if="!selectedStockTitle && $route.path == '/trading'">Search Scrip to start investing</div>

            <div class="top-margin-25 text-center font-08rem font-weight-500 primary-theme-color" v-if="selectedStockTitle && (indice_ltp == null || !indice_ltp)">Trading not available</div>
          </div>
        </el-card>
      </el-col>

      <!-- market sentiment card -->
      <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12" v-if="page_segment == 'equity' && $route.path == '/trading'">
        <MarketSentimentCard v-if="stock_symbol" :stock_code="stock_symbol" :key="stock_symbol"></MarketSentimentCard>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import { TradingPageChartData } from '../mixins/TradingPageChartData';
import { StockDetailsLineChartData } from '../mixins/StockDetailsLineChartData';
import axios from 'axios';
import { serverAddr } from '../networkConfig';
import { HelperNetworkCallBack } from '../mixins/Helper';
import { filterCallBack } from '../mixins/filter';
var echarts = require('echarts');
import CripNotice from 'crip-vue-notice';
import SentimentCard from '@/components/StockAntsSentimentCard.vue';
import moment from 'moment';
import { EventBus } from '../eventBus';
import MarketSentimentCard from '@/components/MarketSentimentCard.vue';

export default {
  name: 'Trade',
  components: { SentimentCard, MarketSentimentCard },
  data() {
    return {
      moment: moment,
      stocks_loading: false,
      search_stock: '',
      search_indice: '',
      stocks_list: [],
      stock_details: {},
      stock_type: 'BSE',
      selected_trade_type: 'BUY',
      target_period: '',
      quantity: 1,
      price: '',
      order_selection_type: false,
      trigger_price: '',
      price_limit: 'MARKET',
      trigger_price_type: false,
      validity: '',
      disclosed_quantity: '',
      stop_loss_checked: false,
      stop_loss_trigger: '',
      target_checked: false,
      target: '',
      required_margin: '',
      select_target: '',
      target_period_list: [],
      active_sub_menu_link: 'MARKET_SENTIMENT',
      market_performance_chart_instance: null,
      active_period: '3M',
      publish_as_reco: true,
      short_term_duration: '',
      long_term_duration: '',
      short_term_target_period_list: [],
      long_term_target_period_list: [],
      reco_price: '',
      reco_price_potential: '',
      validate_reco_price: false,
      reco_price_error_text: '',
      target_price: 0,
      stop_loss: 0,
      target_price_potential: '',
      validate_target_price: false,
      target_price_error_text: '',
      stop_loss_potential: '',
      validate_stop_loss: false,
      stop_loss_error_text: '',
      verified_knowledge_chart_instance: null,
      market_forecast_chart_instance: null,
      socket: {},
      profession_wise_antestimate_details: [],
      toggle_forecasted_details: false,
      result_date: '',
      duration: '',
      antestimate_details: {},
      broker_id: Number(localStorage.getItem('selected_broker')),
      validity_list: [],
      duration_list: [],
      is_trading_details_loading: false,
      is_ltp_loading: false,
      strikeLoading: false,
      bse_ltp: '',
      nse_ltp: '',
      price_type: [],
      is_order_placing: false,
      order_id: null,
      group_id: null,
      serial_no: null,
      segment: null,
      exchange_order_no: null,
      gateway_order_no: null,
      filled_quantity: null,
      selected_lot_size: null,
      // isLocalhost: false,
      page_segment: 'equity',
      selectedStock: null,
      strikeData: [],
      indice_ltp: null,
      selectedStockTitle: '',
      currentEnvironment: {},
      stock_symbol: '',
      isOptionsTradeFromExpertView: false,
      active_price: null,
      market_protection: 5,
      currentUrl: localStorage.getItem('currentUrl') ? localStorage.getItem('currentUrl') : window.location.href,
      isEditable: false,
      customCapitalRequired: null,
      selectedSpotPrice: null,
      optionsStockTitle: '',
      optionsSelectedOrderType: '',
      capitalRequiredValue: '0.00',
      isMarketClose: false,
      funds: 0,
      selectedValidity: '',
    };
  },

  mixins: [StockDetailsLineChartData, HelperNetworkCallBack, filterCallBack, TradingPageChartData],

  async mounted() {
    this.currentEnvironment = JSON.parse(localStorage.getItem('currentEnvironment'));
    this.currentUrl = window.location.href;

    if (this.$store.state.selected_order.stock_id) {
      this.page_segment = this.$store.state.selected_order.segment;

      if (this.$store.state.selected_order.segment == 'equity') {
        // this.clearAllFields();

        this.selectedValidity = this.$store.state.selected_order.duration;

        if (this.$store.state.selected_order_type && this.$store.state.selected_order_type == 'SELL') {
          this.selected_trade_type = this.$store.state.selected_order_type;
        }

        if (this.$store.state.selected_order.order_type) {
          this.selected_trade_type = this.$store.state.selected_order.order_type;
        }
        var stock_details = this.$store.state.selected_order;
        this.search_stock = this.$store.state.selected_order.stock_id;

        this.searchStockList(stock_details.symbol);
        this.handleStock(this.search_stock, 'limit');
      } else if (this.$store.state.selected_order.segment == 'options') {

        this.optionsSelectedOrderType = this.$store.state.selected_order.order_type;

        this.is_trading_details_loading = true;
        // if (this.userProfile.utm_source == 'HDFC Sky') {
        this.selected_trade_type = this.$store.state.selected_order.order_type;
        // }
        this.searchStockList(this.$store.state.selected_order.title);
        this.isOptionsTradeFromExpertView = true;
      }
    }

    this.currentEnvironment = JSON.parse(localStorage.getItem('currentEnvironment'));

    if (this.currentEnvironment.utm_source == 'Nirman' || this.currentEnvironment.utm_source == 'Paytm Money' || this.currentEnvironment.utm_source == 'Nuvama' || this.currentEnvironment.utm_source == 'Tradeplus') {
      this.page_segment = localStorage.getItem('market_type') ? localStorage.getItem('market_type') : 'equity';
    }
    if (localStorage.getItem('selected_broker')) {
      this.getFundDetailsNetWorkCallBack();
    }

    this.checkMarketStatus();
  },
  methods: {
    checkMarketStatus() {
      var format = 'hh:mm:ss';

      // real time
      var time = moment();
      var todayDate = moment().format('YYYY-MM-DD');

      var beforeTime = moment('09:15:00', format);
      var afterTime = moment('15:30:00', format);

      if (time.isBetween(beforeTime, afterTime)) {
        serverAddr
          .get('/base/v1/holiday')
          .then((response) => {
            // check for market holiday

            this.isMarketClose = response.data.data.includes(todayDate) == true ? true : false;

            this.price_limit = this.isMarketClose ? 'LIMIT' : 'MARKET';
          })
          .catch(function (error) {
            console.log(error);
          });
      } else {
        this.isMarketClose = true;
        this.price_limit = 'LIMIT';
      }
    },

    // For equity capital req
    calculateCapitalRequired() {
      const stockPrice = this.stock_type === 'BSE' ? parseFloat(this.bse_ltp || 0) : parseFloat(this.nse_ltp || 0);

      const effectivePrice = this.price_limit === 'LIMIT' ? parseFloat(this.price || 0) : stockPrice;

      return this.quantity * effectivePrice;
    },

    toggleEdit() {
      this.isEditable = !this.isEditable;

      // Reset the custom value when disabling edit
      if (!this.isEditable) {
        this.customCapitalRequired = null;
      }

      if (!this.isEditable) {
        this.syncCapitalToData();
      }
    },

    getCurrentPriceOfSelectedStock(title) {
      serverAddr
        .get(`/options/get_indices_cmp?title=${title}`)
        .then((response) => {
          if (response.data.status) {
            var data = response.data.data;
            this.selectedSpotPrice = data.spot_price;
          }
        })
        .catch(function (error) {
          console.log(error);
        });
    },

    // for options capital req
    syncCapitalToData() {
      // Log default order type logic
      var orderType = this.optionsSelectedOrderType || this.selected_trade_type;

      // Log capital value
      var value = parseFloat(this.capitalRequiredValue) || 0;

      if (orderType === 'BUY') {
        if (this.price_limit === 'MARKET' && this.indice_ltp > 0) {
          this.quantity = value / (this.selected_lot_size * this.indice_ltp);
        } else if (this.price_limit === 'LIMIT' && this.price > 0) {
          this.quantity = value / (this.selected_lot_size * this.price);
        }
      } else if (orderType === 'SELL') {
        const exposure_margin = Number(this.selectedSpotPrice) * Number(this.selected_lot_size) * 0.02;
        const span_margin = 100000; // Assuming a static value for span margin

        const total_margin = exposure_margin + span_margin;

        if (total_margin > 0) {
          this.quantity = value / total_margin;
        }
      }
    },

    getFundDetailsNetWorkCallBack() {
      this.loading = true; //displayed loader

      serverAddr
        .post('/trade/v1/fund', {
          broker_id: localStorage.getItem('selected_broker') ? Number(localStorage.getItem('selected_broker')) : '',
        })
        .then((response) => {
          if (response.data.status) {
            this.funds = response.data.data;
          } else {
            this.funds = {};
          }

          this.loading = false; //hide loader
        })
        .catch((error) => {
          console.log(error);
          this.loading = false; //hide loader
          this.funds = {};
        });
    },
    checkValidationForBO() {
      if (this.userProfile.utm_source == 'Aliceblue') {
        if (this.stop_loss > this.active_price && this.active_price > this.target_price && this.order_selection_type) {
          return true;
        } else {
          return false;
        }
      } else if (this.userProfile.utm_source == 'Zebu' || this.userProfile.utm_source == 'Enrich Money') {
        if ((this.stop_loss > this.active_price || this.active_price > this.target_price) && this.validity == 'B') {
          return true;
        } else {
          return false;
        }
      } else {
        return false;
      }
    },
    setPrice(price, marketType) {
      if (this.page_segment == 'equity') {
        // set stock price for limit
        if (price == 'NSE') {
          this.price = this.nse_ltp;
        } else if (price == 'BSE') {
          this.price = this.bse_ltp;
        }
      } else {
        this.price = this.indice_ltp;
      }

      if (marketType == 'MARKET') {
        this.price = 0;
      }

      this.checkPrice(price);
    },
    checkPrice(price, segment) {
      if (this.order_selection_type || this.userProfile.utm_source == 'Zebu' || this.userProfile.utm_source == 'Enrich Money') {
        // if price is on market price
        if (this.price_limit == 'MARKET') {
          if (segment && segment == 'option') {
            this.active_price = price;
            this.active_price = Number(this.active_price);
          } else {
            if (price == 'BSE') {
              this.order_selection_type = false;
              if (this.userProfile.utm_source == 'Zebu' || this.userProfile.utm_source == 'Enrich Money') {
                this.active_price = Number(this.bse_ltp);
              }
            } else if (price == 'NSE') {
              this.active_price = Number(this.nse_ltp);
            }
          }
        } else {
          this.active_price = this.price;
        }
      }
    },
    getStrikePrice(item) {
      if (item) {
        this.selectedStockTitle = '';
        this.search_stock = '';
        let filtered_stock = this.stocks_list.filter((e) => {
          return e.id == item;
        })[0];

        if (this.isOptionsTradeFromExpertView) {
          filtered_stock = this.stocks_list.filter((e) => {
            if (e.title == this.$store.state.selected_order.title && e.expiry == this.$store.state.selected_order.expiry) {
              return e;
            }
          })[0];

          if (this.price_limit == 'LIMIT') {
            this.price = this.$store.state.selected_order.entryPrice;
          }
        }
        this.selectedStock = filtered_stock;
        this.stocks_list = [];

        this.getStrikeDataCalBack();
      } else {
        this.clearAllFields();
        this.search_stock = '';
      }
    },
    getStrikeDataCalBack() {
      this.strikeLoading = true;
      const { title, expiry } = this.selectedStock;

      serverAddr
        .get(`/options/scrips?title=${title}&expiry=${expiry}&page_per_entries=2000&page_number=1`)
        .then((response) => {
          this.strikeData = [];
          if (response.data.status) {
            var strikeData = response.data.data;
            strikeData.forEach((element) => {
              var obj = {
                id: element.id,
                label: element.strike + element.instrument_type,
                ltp: element.ltp,
                timeStamp: element.last_traded_timestamp,
                lot_size: element.lot_size,
                expiry: element.expiry,
                symbol: element.symbol,
              };

              this.strikeData.push(obj);
            });

            // Call getCurrentPriceOfSelectedStock() with the title
            this.getCurrentPriceOfSelectedStock(title);

            if (this.isOptionsTradeFromExpertView) {
              this.search_indice = this.$store.state.selected_order.title + this.$store.state.selected_order.expiry;
              this.search_stock = this.$store.state.selected_order.leg_id;
              this.getDataForOptions(this.search_stock);
            }
          } else {
            // this.isOpen = false; //closed searched stock result list
            this.strikeData = [];
          }
          this.strikeLoading = false;
        })
        .catch(
          function (error) {
            this.strikeLoading = false;
            console.log('error');
          }.bind(this)
        );
    },

    selectPeriod(period) {
      if (period == '1M') {
        this.active_period = '1M';
      } else if (period == '3M') {
        this.active_period = '3M';
      } else if (period == '6M') {
        this.active_period = '6M';
      }
    },

    initChartInstances() {
      let market_performance_container = this.$refs['marketPerformance'];
      this.market_performance_chart_instance = echarts.init(market_performance_container, null, this.initOptions);
      this.market_performance_chart_instance.showLoading(this.loader_default); //show loader on chart
    },

    //refresh volume shockers chart instance
    clearmarketPerformanceChartInstance() {
      this.market_performance_chart_instance.clear();
    },

    //to trigger changes on chart e.g. to reflect changes data
    reRenderMarketPerformanceChartInstance() {
      // this.clearmarketPerformanceChartInstance();
      this.market_performance_chart_instance.setOption(this.marketPerformanceChart);
    },

    clearVerifiedKnowledgeChartInstance() {
      this.verified_knowledge_chart_instance.clear();
    },

    //to trigger changes on graph e.g. to reflect changes data
    reRenderVerifiedKnowledgeChartInstance() {
      this.clearVerifiedKnowledgeChartInstance();
      this.verified_knowledge_chart_instance.setOption(this.verifiedKnowledgeChart);
    },

    clearMarketForecastChartInstance() {
      this.market_forecast_chart_instance.clear();
    },

    //to trigger changes on graph e.g. to reflect changes data
    reRenderMarketForecastChartInstance() {
      this.clearMarketForecastChartInstance();
      this.market_forecast_chart_instance.setOption(this.marketForecastChart);
    },
    //  this.searchStockList(this.$store.state.selected_order.title);
    searchStockList(query) {
      this.optionsStockTitle = query;
      // this.getCurrentPriceOfSelectedStock();
      this.stocks_loading = true;
      // this.clearAllFields();
      this.stocks_list = [];
      serverAddr
        .post('/trade/v1/search_equity_option_stocks', {
          page_segment: this.page_segment,
          page_no: 1,
          page_per_entries: 500,
          search: query,
        })
        .then((response) => {
          if (response.data.status) {
            this.stocks_list = response.data.data;

            if (this.isOptionsTradeFromExpertView) {
              // this.search_indice = this.$store.state.selected_order.stock_id;
              this.getStrikePrice(this.$store.state.selected_order.stock_id);
            }
          } else {
            this.stocks_list = [];
          }
          this.stocks_loading = false;
        })
        .catch(
          function (error) {
            console.log(error, 'error');
            this.stocks_loading = false;
          }.bind(this)
        );
    },
    clearAllFields() {
      // this.order_id = null;
      // this.validity = "";
      // this.duration = "";
      // this.disclosed_quantity = "";

      // v-if="!stock_details.name && (!bse_ltp || !nse_ltp)
      this.stock_details = {};
      this.bse_ltp = '';
      this.nse_ltp = '';
      this.search_stock = '';
      this.search_indice = '';
      this.stocks_list = [];
      this.selectedStockTitle = '';
      this.selectedValidity = '';
      this.indice_ltp = null;
      this.selected_trade_type = 'BUY';
      this.stock_symbol = '';
      this.active_price = 0;
      this.order_selection_type = false;
      this.stop_loss = 0;
      this.target_price = 0;
      this.price = 0;
      this.quantity = 1;
      this.market_protection = 5;
      this.price_limit = this.isMarketClose ? 'LIMIT' : 'MARKET';
      this.isOptionsTradeFromExpertView = false;
    },
    handleStock(stock, orderType) {
      if (stock) {
        this.$store.commit('commitStockIdForSentimentCard', stock);

        let filtered_stock = this.stocks_list.filter((e) => {
          return e.id == stock;
        })[0];

        this.stock_symbol = filtered_stock ? filtered_stock.symbol : '';

        setTimeout(() => {
          this.getCommonIndexData();
        }, 400);
      } else {
        this.clearAllFields();
      }

      if (!orderType) {
        this.order_id = null;
      }
    },

    setPriceTypeForShareIndia() {
      if ((this.currentEnvironment && this.currentEnvironment.utm_source === 'Share India Trade') || this.currentUrl.includes('shareindia-trade.stockants.com')) {
        this.price_limit = 'LIMIT';
        // this.setPrice(this.indice_ltp, "LIMIT");
      }
    },

    getDataForOptions(stock) {
      if (stock) {
        // default bracket order
        if (this.userProfile.utm_source == 'AliceBlue') {
          this.order_selection_type = true;
        }
        let filtered_stock = this.strikeData.filter((e) => {
          return e.id == stock;
        })[0];

        this.selectedStockTitle = filtered_stock.symbol;
        this.selected_lot_size = filtered_stock.lot_size;

        this.is_trading_details_loading = true; //enabled loader

        this.setPriceTypeForShareIndia();

        this.checkPrice(filtered_stock.ltp, 'option');
        axios
          .all([this.getDeliverType(), this.getLTPPrice()])
          .then(
            // stock_performance_res
            axios.spread(
              async function (delivery_type_res, ltp_res) {
                if (delivery_type_res.data.status) {
                  if (delivery_type_res.data.data.product_type.length) {
                    this.validity_list = delivery_type_res.data.data.product_type;

                    // Hide CNC for Hdfc sky
                    if (this.userProfile.utm_source == 'HDFC Sky') {
                      this.validity_list = this.validity_list.filter((element) => element.title !== 'CNC');
                    }

                    // Hide CNC (Delivery) for Bajaj Broking
                    if (this.userProfile.utm_source == 'Bajaj Broking') {
                      this.validity_list = this.validity_list.filter((element) => element.value !== 'D');
                    }

                    // Hide C (Delivery) for Paytm Money and Almondz trade
                    if (this.userProfile.utm_source == 'Paytm Money' || this.userProfile.utm_source == 'Almondz Trade') {
                      this.validity_list = this.validity_list.filter((element) => element.value !== 'C');
                    }

                    // Hide MIS & CNC for SKI Capital
                    if (this.userProfile.utm_source == 'SKI Capital') {
                      this.validity_list = this.validity_list.filter((element) => element.value == 'NRML');
                    }

                    // Show only CNC for Ashlar
                    if (this.userProfile.utm_source == 'Ashlar India Trade') {
                      this.validity_list = this.validity_list.filter((element) => element.value !== 'CNC');
                    }

                    //  Don't set default validity while modifing order
                    this.validity = this.validity_list[0].value;
                  }

                  if (delivery_type_res.data.data.duration.length) {
                    this.duration_list = delivery_type_res.data.data.duration;

                    this.target_period = this.duration_list[0].value;
                  }
                }

                if (ltp_res.data.status && ltp_res.data.data.length) {
                  this.indice_ltp = ltp_res.data.data[0].ltp;
                  this.stock_type = ltp_res.data.data[0].exchange;
                }

                // remove expert view page indice details and set 0 for default value
                if (this.$store.state.selected_order.stock_id) {
                  this.stop_loss = this.$store.state.selected_order.stop_loss;
                  this.target_price = this.$store.state.selected_order.target_price;

                  this.$store.commit('commitSelectedOrder', {});
                } else {
                  this.stop_loss = 0;
                  this.target_price = 0;
                }

                this.is_trading_details_loading = false; //disabled loader
              }.bind(this)
            )
          )
          .catch((err) => {
            console.log(err);
            this.is_trading_details_loading = false; //disabled loader
          })
          .finally(() => {
            this.is_trading_details_loading = false; //disabled loader
          });
      }
    },

    async changeTargetPeriod() {
      this.market_performance_chart_instance.showLoading(this.loader_default); //show loader on chart

      this.market_performance_chart_series[0].data = []; //cleared previously filled data
      // this.reRenderMarketPerformanceChartInstance(); //render reco details chart

      // get selected target period's obj
      let target_period = this.target_period_list.find((e) => {
        return e.counter == this.select_target;
      });

      if (Object.keys(target_period).length) {
        let reco_details_res = await this.getRecoDetailsChartDataNetWorkCallBack(target_period.number, target_period.duration, target_period.year); //called api to get reco details chart data

        if (reco_details_res.data.status) {
          this.antestimate_details = {};

          // this.is_antestimate_chart_data_available = true;    //hide no data labels from chart

          let reco_details = reco_details_res.data.data.market_sentiments;

          this.antestimate_details = {
            antestimate_no: reco_details_res.data.data.ants_number,
            market_return: reco_details_res.data.data.market_return,
            forecasted_market_return: reco_details_res.data.data.forecasted_market_return,
          };

          for (let key in reco_details) {
            if (reco_details[key]) {
              let obj = {
                name: key ? key.toUpperCase() : '',
                value: reco_details[key],
                itemStyle: {
                  color: key == 'buy' ? '#079e3e' : key == 'sell' ? '#d60918' : '#e2ba00',
                },
              };

              this.market_performance_chart_series[0].data.push(obj);
            }
          }

          this.profession_wise_antestimate_details = reco_details_res.data.data.profession_wise_data;
        }
      }

      // this.market_performance_chart_instance.hideLoading(this.loader_default); //show loader on chart
      // this.reRenderMarketPerformanceChartInstance(); //render reco details chart
    },
    setStockDetailsForModifyOrder() {
      var stock_details = this.$store.state.selected_order;

      // AutoFill Data for Modify Order
      this.order_id = stock_details.id;
      this.search_stock = this.$store.state.selected_order.stock_id;

      this.stop_loss = this.$store.state.selected_order.stop_loss;
      this.target_price = this.$store.state.selected_order.target_price;

      if (stock_details.group_id) {
        this.group_id = stock_details.group_id;
      }
      if (stock_details.serial_no) {
        this.serial_no = stock_details.serial_no;
      }
      if (stock_details.segment) {
        this.segment = stock_details.segment;
      }
      if (stock_details.product) {
        this.validity = stock_details.product;
      } else {
        this.validity = 'MIS';
      }

      // if user is from choice
      if (localStorage.getItem('selected_broker') == 16) {
        this.exchange_order_no = stock_details.exchange_order_no;
        this.gateway_order_no = stock_details.gateway_order_no;
      }
      // if user is from Tradeplus or Nirman
      if (localStorage.getItem('selected_broker') == 15 || localStorage.getItem('selected_broker') == 17) {
        this.filled_quantity = stock_details.filled_quantity;
      }
      if (stock_details.quantity) {
        this.quantity = stock_details.quantity;
      }
      this.duration = stock_details.duration;
      this.disclosed_quantity = stock_details.disclosed_quantity;

      var price_limit = stock_details.order_type;

      // if limit
      if (price_limit == 'Market' || price_limit == 'MKT' || price_limit == 'market' || price_limit == 'MARKET') {
        this.price_limit = 'MARKET';
        // this.price = stock_details.price;
      } else {
        this.price_limit = 'LIMIT';
      }

      this.$store.commit('commitSelectedOrder', {});
    },

    getCommonIndexData() {
      this.is_trading_details_loading = true; //enabled loader

      this.market_performance_chart_series[0].data = []; //cleared previously filled data
      // this.reRenderMarketPerformanceChartInstance(); //render reco details chart

      this.stock_details = {};
      this.antestimate_details = {};
      this.target_period_list = [];
      this.profession_wise_antestimate_details = [];
      this.validity_list = [];
      this.duration_list = [];
      this.price_type = [];
      this.bse_ltp = '';
      this.nse_ltp = '';
      // this.selectedValidity = '';

      this.order_id = null;
      this.validity = '';
      this.quantity = 1;
      this.market_protection = 5;
      this.duration = '';
      this.disclosed_quantity = '';
      // this.price_limit = 'MARKET';
      this.price = '';
      this.order_selection_type = false;
      this.stop_loss = 0;
      this.target_price = 0;

      // Preselect 'LIMIT' if the environment is 'Share India Trade' or the URL matches
      this.setPriceTypeForShareIndia();

      // get stockdetails for modify order
      if (this.$store.state.selected_order.stock_id) {
        this.setStockDetailsForModifyOrder();
      }
      // this.getStockPerformanceNetWorkCallBack()
      axios
        .all([this.getStockDetailsNetWorkCallBack(), this.getTargetperiodNetWorkCallBack(), this.getDeliverType(), this.getLTPPrice()])
        .then(
          // stock_performance_res
          axios.spread(
            async function (stock_details_res, target_period_res, delivery_type_res, ltp_res) {
              // for stock details
              if (stock_details_res.status && stock_details_res.data.data.length) {
                this.stock_details = stock_details_res.data.data[0];
              }

              // for target period list
              if (target_period_res.data.status && target_period_res.data.data.length) {
                this.target_period_list = target_period_res.data.data;

                this.select_target = target_period_res.data.data[0].counter; //select by default first value

                this.result_date = target_period_res.data.data[0].result_date;
                this.duration = target_period_res.data.data[0].duration;

                let reco_details_res = await this.getRecoDetailsChartDataNetWorkCallBack(target_period_res.data.data[0].number, target_period_res.data.data[0].duration, target_period_res.data.data[0].year); //called api to get reco details chart data

                if (reco_details_res.data.status) {
                  // this.is_antestimate_chart_data_available = true;    //hide no data labels from chart

                  let reco_details = reco_details_res.data.data.market_sentiments;

                  this.antestimate_details = {
                    antestimate_no: reco_details_res.data.data.ants_number,
                    market_return: reco_details_res.data.data.market_return,
                    forecasted_market_return: reco_details_res.data.data.forecasted_market_return,
                  };

                  for (let key in reco_details) {
                    if (reco_details[key]) {
                      let obj = {
                        name: key ? key.toUpperCase() : '',
                        value: reco_details[key],
                        itemStyle: {
                          color: key == 'buy' ? '#079e3e' : key == 'sell' ? '#d60918' : '#e2ba00',
                        },
                      };

                      this.market_performance_chart_series[0].data.push(obj);
                    }
                  }

                  this.profession_wise_antestimate_details = reco_details_res.data.data.profession_wise_data;
                } else {
                  // this.is_antestimate_chart_data_available = false;    //show no data labels from chart
                }
              } else {
                this.target_period_list = [];
                this.select_target = '';
              }

              if (delivery_type_res.data.status) {
                if (delivery_type_res.data.data.product_type.length) {
                  this.validity_list = delivery_type_res.data.data.product_type;

                  //  Don't set default validity while modifing order
                  if (!this.$store.state.selected_order.stock_id) {
                    this.validity = this.validity_list[0].value;
                  }
                }

                if (delivery_type_res.data.data.duration.length) {
                  this.duration_list = delivery_type_res.data.data.duration;

                  this.target_period = this.duration_list[0].value;
                }

                if (delivery_type_res.data.data.segment.length) {
                  this.price_type = delivery_type_res.data.data.segment;
                  this.stock_type = this.price_type[0].value;
                }
              }

              // Hide CNC for Ashlar
              if (this.userProfile.utm_source == 'Ashlar India Trade') {
                this.validity_list = this.validity_list.filter((element) => element.value == 'CNC');
              }

              if (this.selectedValidity && this.selectedValidity.length) {
                this.selectedValidity = this.selectedValidity.toLowerCase() === 'intraday' ? 'Intraday' : 'Delivery';
                var validityObj = this.validity_list.find((item) => item.title.toLowerCase() === this.selectedValidity.toLowerCase());
                this.validity = validityObj ? validityObj.value : this.validity_list[0].value;
              } else {
                //  Don't set default validity while modifing order
                this.validity = this.validity_list[0].value;
              }


              if (ltp_res.data.status && ltp_res.data.data.length) {
                for (let i = 0; i < ltp_res.data.data.length; i++) {
                  if (ltp_res.data.data[i].identity == 'BSE') {
                    this.bse_ltp = ltp_res.data.data[i].ltp;
                  } else if (ltp_res.data.data[i].identity == 'NSE') {
                    this.nse_ltp = ltp_res.data.data[i].ltp;
                  }
                }

                if (this.userProfile.utm_source == 'AliceBlue') {
                  this.order_selection_type = true;
                  this.checkPrice('NSE');
                }
              }

              this.is_trading_details_loading = false; //disabled loader
            }.bind(this)
          )
        )
        .catch((err) => {
          this.is_trading_details_loading = false; //disabled loader
        })
        .finally(() => {
          this.is_trading_details_loading = false; //disabled loader
        });
    },
    // modifyOrder(){

    // },

    placeOrderOptions(orderType) {
      if (this.price_limit != 'MARKET' && this.quantity && this.price && this.validity) {
        this.saveOrderOptions(orderType);
      } else if (this.price_limit == 'MARKET' && this.quantity && this.validity) {
        this.saveOrderOptions(orderType);
      } else {
        this.$message({
          customClass: 'notification-tag',
          showClose: true,
          message: 'Please fill all required fileds',
          type: 'error',
        });
      }
    },
    saveOrderOptions(orderType) {
      this.is_order_placing = true; //displayed loader
      var apIUrl;

      var obj = {
        broker_id: Number(this.broker_id),
        stock_id: this.search_stock,
        transaction_type: this.selected_trade_type.toUpperCase(),
        exchange: this.stock_type,
        order_type: this.price_limit,
        validity: this.target_period,
        product_type: this.validity,
        price: this.price_limit == 'MARKET' ? null : this.price,
        quantity: this.quantity,
        disclosed_quantity: this.disclosed_quantity ? this.disclosed_quantity : null,
      };
      if (this.order_selection_type || ((this.userProfile.utm_source == 'Zebu' || this.userProfile.utm_source == 'Enrich Money') && this.validity == 'B')) {
        obj.stoploss = this.stop_loss;
        obj.target_price = this.target_price;
        obj.complexty = 'bo';
      }
      if (this.userProfile.utm_source == 'Bajaj Broking') {
        obj.market_protection = this.market_protection;
      }

      if (orderType == 'place') {
        apIUrl = '/trade/v1/place_order';
        obj.stoploss = this.order_selection_type || ((this.userProfile.utm_source == 'Zebu' || this.userProfile.utm_source == 'Enrich Money') && this.validity == 'B') ? this.stop_loss : 0;
        obj.page_segment = this.page_segment;
      }
      serverAddr
        .post(apIUrl, obj)
        .then((response) => {
          if (response.data.status) {
            new CripNotice({
              title: 'Success',
              description: response.data.validation,
              type: 'success',
              duration: 3,
            });

            this.closeTradePopup();
          }

          this.is_order_placing = false; //hide loader
        })
        .catch(
          function (error) {
            console.log(error);
            this.is_order_placing = false; //hide loader
          }.bind(this)
        );
    },

    placeOrder(orderType) {
      var isBracketOrder = true;
      if (this.order_selection_type || ((this.userProfile.utm_source == 'Zebu' || this.userProfile.utm_source == 'Enrich Money') && this.validity == 'B')) {
        if (this.target_period && this.stop_loss) {
          isBracketOrder = true;
        } else {
          isBracketOrder = false;
        }
      }

      if (this.price_limit != 'MARKET' && this.quantity && this.price && this.validity && this.market_protection && isBracketOrder) {
        this.saveOrder(orderType);
      } else if (this.price_limit == 'MARKET' && this.quantity && this.validity && this.market_protection) {
        this.saveOrder(orderType);
      } else {
        this.$message({
          customClass: 'notification-tag',
          showClose: true,
          message: 'Please fill all required fileds',
          type: 'error',
        });
      }
    },

    saveOrder(orderType) {
      this.is_order_placing = true; //displayed loader
      var apIUrl;
      var obj = {
        broker_id: Number(this.broker_id),
        stock_id: this.search_stock,
        transaction_type: this.selected_trade_type.toUpperCase(),
        exchange: this.stock_type,
        order_type: this.price_limit,
        validity: this.target_period,
        product_type: this.validity,
        price: this.price_limit == 'MARKET' ? null : this.price,
        quantity: this.quantity,
        market_protection: this.market_protection,
      };
      if (this.order_selection_type || ((this.userProfile.utm_source == 'Zebu' || this.userProfile.utm_source == 'Enrich Money') && this.validity == 'B')) {
        obj.stoploss = this.stop_loss;
        obj.target_price = this.target_price;
        obj.complexty = 'bo';
      }
      if (orderType == 'modify') {
        if (this.serial_no && this.group_id && this.segment) {
          obj.serial_no = this.serial_no;
          obj.group_id = this.group_id;
          obj.segment = this.segment;
        }
        apIUrl = '/trade/v1/modify_order';
        obj.order_id = this.order_id;
        obj.stopPrice = 0;
        obj.page_segment = this.page_segment;

        // if user is from choice
        if (localStorage.getItem('selected_broker') == 16) {
          obj.exchange_order_no = this.exchange_order_no;
          obj.gateway_order_no = this.gateway_order_no;
        }
        // if user is from Nirman or Tradeplus
        if (localStorage.getItem('selected_broker') == 15 || localStorage.getItem('selected_broker') == 17) {
          obj.filled_quantity = this.filled_quantity;
        }
      } else if (orderType == 'place') {
        apIUrl = '/trade/v1/place_order';
        obj.stoploss = this.order_selection_type || ((this.userProfile.utm_source == 'Zebu' || this.userProfile.utm_source == 'Enrich Money') && this.validity == 'B') ? this.stop_loss : 0;
        obj.page_segment = this.page_segment;
      }
      serverAddr
        .post(apIUrl, obj)
        .then((response) => {
          if (response.data.status) {
            new CripNotice({
              title: 'Success',
              description: response.data.validation,
              type: 'success',
              duration: 3,
            });
          }

          this.is_order_placing = false; //hide loader
          this.closeTradePopup();
        })
        .catch(
          function (error) {
            console.log(error);
            this.is_order_placing = false; //hide loader
          }.bind(this)
        );
    },
    closeTradePopup() {
      this.$store.commit('tradePopupAction', false);
    },

    // api to get stocks details
    getStockDetailsNetWorkCallBack() {
      return serverAddr
        .get(`/market_dashboard/indices_info?stock_id=${this.search_stock}`, {})
        .then((response) => {
          return response;
        })
        .catch(
          function (error) {
            console.log(error);
          }.bind(this)
        );
    },

    // api to get target period of market performance of stockants
    getTargetperiodNetWorkCallBack() {
      return serverAddr
        .get(`/market_dashboard/target_period_dropdown?stock_id=${this.search_stock}`, {})
        .then((response) => {
          return response;
        })
        .catch(
          function (error) {
            console.log(error);
          }.bind(this)
        );
    },

    getDeliverType() {
      return serverAddr
        .post(`/trade/v1/setting`, {
          broker_id: Number(this.broker_id),
        })
        .then((response) => {
          return response;
        })
        .catch(
          function (error) {
            console.log(error);
          }.bind(this)
        );
    },

    // api to get ltp price
    getLTPPrice() {
      return serverAddr
        .post(`/trade/v1/ltp`, {
          stock_id: this.search_stock,
          broker_id: Number(this.broker_id),
          page_segment: this.page_segment,
        })
        .then((response) => {
          return response;
        })
        .catch(
          function (error) {
            console.log(error);
          }.bind(this)
        );
    },

    async refreshLTP() {
      this.is_ltp_loading = true;

      let ltp_res = await this.getLTPPrice();

      if (this.page_segment == 'equity') {
        if (ltp_res.data.status && ltp_res.data.data.length) {
          for (let i = 0; i < ltp_res.data.data.length; i++) {
            if (ltp_res.data.data[i].exchange == 'BSE') {
              this.bse_ltp = ltp_res.data.data[i].ltp;
            } else if (ltp_res.data.data[i].exchange == 'NSE') {
              this.nse_ltp = ltp_res.data.data[i].ltp;
            }
          }
        }
      } else {
        if (ltp_res.data.status && ltp_res.data.data.length) {
          this.indice_ltp = ltp_res.data.data[0].ltp;
          this.stock_type = ltp_res.data.data[0].exchange;
        }
      }

      this.is_ltp_loading = false;
    },

    // api to get reco details chart data
    getRecoDetailsChartDataNetWorkCallBack(number, duration, year) {
      return serverAddr
        .get(`/market_dashboard/market_performance_stockants?stock_id=${this.search_stock}&duration=${duration}&number=${number}&year=${year}`, {})
        .then((response) => {
          return response;
        })
        .catch(
          function (error) {
            console.log(error);
          }.bind(this)
        );
    },

    async setActiveSubMenuLink(label) {
      this.toggle_forecasted_details = false;

      if (label == 'MARKET_SENTIMENT') {
        this.active_sub_menu_link = 'MARKET_SENTIMENT';

        this.market_performance_chart_series[0].data = [];
        this.reRenderMarketPerformanceChartInstance();

        // if(this.$refs['marketForecastChart']){
        //     this.$refs.marketForecastChart.getElementsByTagName('div')[0].style.height = '0px';
        // }

        // reinit chart instances
        setTimeout(async () => {
          // let verified_knowledge_chart_container = this.$refs["verifiedKnowledgeChart"];
          // this.verified_knowledge_chart_instance = echarts.init(verified_knowledge_chart_container, null, this.initOptions);
          // this.verified_knowledge_chart_instance.showLoading(this.loader_default);      //show loader on chart

          let market_performance_container = this.$refs['marketPerformance'];
          this.market_performance_chart_instance = echarts.init(market_performance_container, null, this.initOptions);

          this.$refs.marketPerformance.getElementsByTagName('div')[0].style.height = '160px';

          let duration = this.target_period_list.filter((e) => {
            return this.select_target == e.counter;
          });

          if (duration.length) {
            // get result date and duration from selected target period
            this.result_date = duration[0].result_date;
            this.duration = duration[0].duration;

            this.market_performance_chart_instance.showLoading(this.loader_default); //show loader on chart

            let reco_details_res = await this.getRecoDetailsChartDataNetWorkCallBack(duration[0].number, duration[0].duration, duration[0].year); //called api to get reco details chart data

            if (reco_details_res.data.status && reco_details_res.data.data.market_sentiments) {
              // this.is_antestimate_chart_data_available = true;    //hide no data labels from chart

              let reco_details = reco_details_res.data.data.market_sentiments;
              // this.antestimate = reco_details_res.data.data.ants_number;

              for (let key in reco_details) {
                if (reco_details[key]) {
                  let obj = {
                    name: key ? key.toUpperCase() : '',
                    value: reco_details[key],
                    itemStyle: {
                      color: key == 'buy' ? '#079e3e' : key == 'sell' ? '#d60918' : '#e2ba00',
                    },
                  };

                  this.market_performance_chart_series[0].data.push(obj);
                }
              }
            } else {
              // this.is_antestimate_chart_data_available = false;    //show no data labels from chart
            }
          }

          // this.market_performance_chart_instance.hideLoading(
          //   this.loader_default
          // ); //show loader on chart
          // this.reRenderMarketPerformanceChartInstance(); //render reco details chart

          // this.verified_knowledge_chart_instance.hideLoading(this.loader_default);      //show loader on chart
          // this.reRenderVerifiedKnowledgeChartInstance();      //render reco details chart
        }, 200);
      } else if (label == 'FORECAST') {
        this.active_sub_menu_link = 'FORECAST';

        if (this.$refs['marketPerformance']) {
          this.$refs.marketPerformance.getElementsByTagName('div')[0].style.height = '0px';
        }

        // setTimeout(() => {

        //     // init chart instance
        //     // let market_forecast_container = this.$refs["marketForecastChart"];
        //     // this.market_forecast_chart_instance = echarts.init(market_forecast_container, null, this.initOptions);
        //     // this.$refs.marketForecastChart.getElementsByTagName('div')[0].style.height = '285px';

        //     // this.market_forecast_chart_instance.showLoading(this.loader_default);

        //     for(let i=0; i<4; i++){
        //         let obj = {
        //             type: 'line',
        //             lineStyle: {
        //                 type: i == 2 ? 'dashed' : 'solid'
        //             },
        //             showSymbol: false,
        //             name: i == 0 ? 'Broker' : i == 1 ? 'Analyst' : i == 2 ? 'Fianancial Advisor' : 'Retail',
        //             data: i == 0 ?  [15, 23, 24, 18, 15, 17] : i == 1 ? [null, null, null, 18, 13, 14] : i == 2 ? [null, null, null, 18, 25, 30] : [null, null, null, 18, 12, 14],
        //             itemStyle: { color: i == 0 ? '#8b8ba0' : i == 1 ? '#f77f59' : i == 1 ? '#03d899' : '#806de2'}
        //         }

        //         this.market_forecast_chart_series.push(obj);
        //     }

        //     this.market_forecast_chart_instance.hideLoading(this.loader_default);      //show loader on chart
        //     this.reRenderMarketForecastChartInstance();
        // }, 300)
      } else if (label == 'LOGIC') {
        this.active_sub_menu_link = 'LOGIC';

        if (this.$refs['marketPerformance']) {
          this.$refs.marketPerformance.getElementsByTagName('div')[0].style.height = '0px';
        }

        // if(this.$refs['marketForecastChart']){
        //     this.$refs.marketForecastChart.getElementsByTagName('div')[0].style.height = '0px';
        // }
      }
    },
  },
  watch: {
    selected_trade_type(newValue) {},
    price_limit(newVal) {
      if (newVal === 'LIMIT' && !this.price) {
        this.stop_loss = null; // Clear stop_loss if LIMIT is selected and price is empty
      }
    },
    price(newVal) {
      if (this.price_limit === 'LIMIT' && !newVal) {
        this.stop_loss = null; // Clear stop_loss if price is cleared while LIMIT is selected
      }
    },
    calculatedCapitalRequired(newValue) {
      if (!this.isEditable) {
        this.capitalRequiredValue = newValue;
      }
    },

    // For options Update quantity dynamically when capitalRequiredValue is manually entered
    capitalRequiredValue(newValue) {
      const value = parseFloat(newValue) || 0;

      if (this.isEditable) {
        if (this.optionsSelectedOrderType === 'BUY') {
          if (this.price_limit === 'MARKET' && this.indice_ltp > 0) {
            this.quantity = Math.floor(value / (this.selected_lot_size * this.indice_ltp));
          } else if (this.price_limit === 'LIMIT' && this.price > 0) {
            this.quantity = Math.floor(value / (this.selected_lot_size * this.price));
          }
        } else if (this.optionsSelectedOrderType === 'SELL') {
          const exposure_margin = Number(this.selectedSpotPrice) * Number(this.selected_lot_size) * 0.02;

          const span_margin = 100000;

          const total_margin = exposure_margin + span_margin;

          if (total_margin > 0) {
            this.quantity = Math.floor(value / total_margin);
          }
        }
      }
    },
  },

  computed: {
    // Capital required for equity
    capitalRequiredComputed: {
      get() {
        // If a custom value is set, return it; otherwise, return the calculated value
        return this.customCapitalRequired !== null ? this.customCapitalRequired : this.calculateCapitalRequired();
      },
      set(value) {
        // Update the custom value when input is edited
        this.customCapitalRequired = value;

        // Update quantity based on entered capital
        const stockPrice = this.stock_type === 'BSE' ? parseFloat(this.bse_ltp || 0) : parseFloat(this.nse_ltp || 0);

        const effectivePrice = this.price_limit === 'LIMIT' ? parseFloat(this.price || 0) : stockPrice;

        // Ensure effectivePrice is not zero to prevent division by zero
        if (effectivePrice > 0) {
          // Calculate the new quantity based on the entered capital
          this.quantity = Math.floor(value / effectivePrice);
        } else {
          this.quantity = 0;
        }

        // If you want to sync the capital required when quantity changes
        if (this.quantity > 0) {
          this.customCapitalRequired = this.quantity * effectivePrice;
        }
      },
    },

    isStopLossInvalid() {
      const stockPrice = this.stock_type === 'BSE' ? parseFloat(this.bse_ltp || 0) : parseFloat(this.nse_ltp || 0);

      const effectivePrice = this.price_limit === 'LIMIT' ? parseFloat(this.price || 0) : stockPrice;

      return this.stop_loss > effectivePrice && this.stop_loss;
    },

    /// for options capital req
    calculatedCapitalRequired() {
      const orderType = this.optionsSelectedOrderType || this.selected_trade_type;

      if (orderType === 'BUY') {
        if (this.price_limit === 'MARKET') {
          const result = (this.quantity * this.selected_lot_size * this.indice_ltp).toFixed(2);
          return result;
        }
        if (this.price_limit === 'LIMIT' && this.price > 0) {
          const result = (this.quantity * this.selected_lot_size * this.price).toFixed(2);
          return result;
        }
        return '0.00';
      }

      if (orderType === 'SELL') {
        const exposure_margin = Number(this.selectedSpotPrice) * Number(this.selected_lot_size) * Number(this.quantity) * 0.02;
        const span_margin = 100000 * Number(this.quantity);

        const total_margin = (exposure_margin + span_margin).toFixed(2);
        return total_margin;
      }
      return '0.00';
    },

    getOrderId() {
      return this.$store.state.selected_order_id;
    },

    getSelectedOrder() {
      return this.$store.state.selected_order;
    },
    userProfile() {
      return JSON.parse(localStorage.getItem('profile'));
    },
  },

  beforeDestroy() {
    this.$store.commit('commitOrderId', '');
    this.$store.commit('commitSelectedOrder', {});
  },
};
</script>

<style lang="scss" scoped>
@import '../css/variable.scss';
@import '../css/common.scss';

.Trade {
  .searched-stock-title {
    font-size: 1.4rem;
  }

  .margin-required {
    padding: 10px;
    background-color: #eff3f4;
  }

  .select-options-dropdown .el-input__inner {
    font-size: 0.8rem;
    height: 32px !important;
    border-bottom-left-radius: 40px;
    border-top-left-radius: 40px;
  }

  .el-select-dropdown__item {
    line-height: 0;
  }

  .trading-type-btn {
    padding: 6px;
    border-radius: 10px;
    max-width: 100px;
    cursor: pointer;
    border: 1px solid #ddd;
    color: #000;
    font-size: 0.8rem;
    font-weight: 500;
    text-align: center;
  }

  .active-buy-btn {
    background: #d1ffd1;
    border-color: #71cb89;
  }

  .active-sell-btn {
    background: #ffdbdb;
    border-color: #f28a8f;
  }

  .order-btn {
    color: #fff;
    border-radius: 5px;
  }

  .antestimate-details {
    background: $secondary-theme-color;
    border-radius: 10px;
    padding: 10px;
  }

  .potential-return-value {
    font-size: 0.7rem;
    font-weight: 600;
    position: absolute;
    top: 8px;
    right: 8px;
    // right: 30%;
    z-index: 1;
    color: #979797;
  }

  .rupees-symbol {
    position: absolute;
    top: 7px;
    left: 15px;
    z-index: 1;
    font-size: 0.9rem;
    color: black;
    font-weight: bold;
  }

  .forecast-descp {
    background: #f3f3ff;
    border-radius: 10px;
    padding: 10px 10px 10px 20px;
  }

  .forecasted-user-table {
    width: 100%;
    border-collapse: collapse;

    th {
      color: #a5a6a8;
      font-size: 13px;
      font-weight: 600;
      padding: 5px;
      border-bottom: 1px solid #ddd;
    }

    td {
      font-size: 12px;
      font-weight: 500;
      text-align: center;
      padding: 15px 10px;
    }

    td:first-child {
      font-weight: 600;
    }
  }
}

.price-container {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 300px;
}

.price-label {
  font-size: 12px;
  font-weight: 500;
  color: #5d5d5d;
  margin-right: 55px;
  white-space: nowrap;
}

.stock-select-container {
  display: flex;
  align-items: center;
  gap: 10px;
  width: 100%;
}

.edit-icon {
  width: 20px;
  height: 20px;
  cursor: pointer;
  margin-top: 7px;
  margin-right: 5px;
}

/* Increased width for larger screens */
@media (min-width: 769px) {
  .ltp-input {
    width: 250px;
  }

  .custom-dropdown {
    width: 300px;
  }
}

@media (max-width: 768px) {
  .price-container {
    flex-direction: column;
    align-items: flex-start;
  }

  .stock-select-container {
    flex-wrap: wrap;
    gap: 8px;
    width: 100%;
  }

  .ltp-input,
  .custom-dropdown {
    width: 100%;
  }

  .price-label {
    margin-bottom: 10px;
  }
}

@media screen and (max-width: 600px) {
  .Trade .searched-stock-title {
    font-size: 1rem;
    flex-direction: column;
    align-items: flex-start;
  }

  .searched-stock-title .label {
    margin-bottom: 5px;
  }

  .searched-stock-title span {
    font-size: 14px;
  }

  .price-container {
    flex-direction: row;
    align-items: center;
    width: 300px;
  }

  .stock-select-container {
    flex-wrap: nowrap;
  }

  .ltp-input,
  .custom-dropdown {
    width: auto;
  }
}
</style>

<style lang="scss">
@import '../css/variable.scss';
@import '../css/common.scss';

.Trade {
  .page-segment-input {
    .el-input__inner {
      border-radius: 15px;
    }
  }

  .segment-radio-btn {
    display: flex;
    justify-content: end;

    .el-button {
      font-weight: 600;
    }
  }

  .stop-loss {
    .el-input__inner {
      color: red;
      border: none;
      background: #f4f4f4;
    }
  }

  .trading-card {
    border-radius: 10px;
    box-shadow: none;

    .search-stock-container {
      margin-left: 10px;
    }
  }

  .el-checkbox__label {
    font-size: 0.8rem;
  }

  .el-radio__label {
    color: #000;
    font-size: 0.8rem;
    font-weight: 700;
  }

  .el-radio__inner {
    height: 12px;
    width: 12px;
  }

  .el-checkbox__input.is-checked + .el-checkbox__label {
    color: #000;
  }

  .el-checkbox__input.is-checked .el-checkbox__inner {
    background-color: $secondary-theme-color;
    border-color: $secondary-theme-color;
  }

  .el-radio__input.is-checked + .el-radio__label {
    color: $secondary-theme-color;
  }

  .el-radio__input.is-checked .el-radio__inner {
    border-color: $secondary-theme-color;
    background: $secondary-theme-color;
  }

  .popover-title-black .el-popover__title {
    color: black !important;
  }

  .target-price-input-section .el-input__inner::placeholder {
    font-size: 0.8rem;
    font-weight: 500;
  }

  .target-price-input .el-input__inner {
    border-radius: 25px;
  }

  .quarter-tag {
    width: 100%;

    input {
      border-radius: 25px;
      // height: 25px;
    }

    input::placeholder {
      // color: $primary-theme-color;
      // font-size: 10px;
      font-weight: 500;
    }
  }

  /* Custom styles for the dropdown */
  .custom-dropdown .el-select__input {
    background-color: blue !important;
    color: white !important;
    // border-color: blue !important;
  }

  /* Custom styles for the dropdown list */
  .custom-dropdown .el-select-dropdown {
    background-color: blue !important;
    color: white !important;
  }

  .ltp-input .el-input__inner {
    background-color: white !important;
    color: black !important;
    border-color: #dcdfe6 !important;
  }

  /* Custom styling for el-select */
  .blue-dropdown .el-input__inner {
    background-color: #3535bc;
    border-color: #3535bc;
    color: white;
  }

  .blue-dropdown .el-input__inner:hover,
  .blue-dropdown .el-input__inner:focus {
    background-color: #3535bc;
    border-color: #3535bc;
    color: white;
    box-shadow: 0 0 5px rgba(0, 123, 255, 0.4);
  }

  /* Dropdown menu background */
  .blue-dropdown .el-select-dropdown {
    background-color: #3535bc;
    color: white;
  }

  /* Hover effect for dropdown items */
  .blue-dropdown .el-select-dropdown__item:hover {
    background-color: #3535bc;
    color: white;
  }

  /* Custom dropdown arrow color */
  .blue-dropdown .el-input__suffix .el-input__icon {
    color: white;
  }
}

@media screen and (max-width: 992px) {
  .Trade .trading-card .search-stock-container {
    margin-left: 0px;
    margin-top: 15px;
  }
}
</style>
